<template lang="pug">
  div.containerContatos
    el-row(:gutter="20").margin.mb-20
      el-col(:span="12")
        app-label(label="CEP", :required="true")
        el-input.full-width(
          v-model="informacoesContatos.cep"
          type="text"
          placeholder="Digite o CEP (XXXXX-XXX)"
          mask="#####-###"
        )
    el-row(:gutter="20").margin.mb-20
      el-col(:span="12")
        app-label(label="Estado", :required="true")
        el-select.full-width(v-model="informacoesContatos.estado" placeholder="Selecione o estado" @change="changeEstado")
          el-option(v-for="estado in estadosBr" :key="estado.codigo" :label="estado.nome" :value="estado.codigo")
      el-col(:span="12", v-if="informacoesContatos.municipio && informacoesContatos.municipio !== ''")
        app-label(label="Município", :required="true")
        el-select.full-width(v-model="informacoesContatos.municipio.id" placeholder="Selecione o município")
          el-option(v-for="item in municipios" :key="item.id" :label="item.nome" :value="item.id")
    el-row(:gutter="20").margin.mb-20
      el-col(:span="12")
        app-label(label="Bairro", :required="true")
        el-input.full-width(
          v-model="informacoesContatos.bairro"
          type="text"
          placeholder="Digite o bairro"
        )
      el-col(:span="12")
        app-label(label="Lougradouro", :required="true")
        el-input.full-width(
          v-model="informacoesContatos.logradouro"
          type="text"
          placeholder="Digite o logradouro"
        )
    el-row(:gutter="20").margin.mb-20
      el-col(:span="12")
        app-label(label="Telefone para contato", :required="true")
        el-input.full-width(
          v-model="tempTelefone"
          type="text"
          placeholder="+55 (XX) XXXXX-XXXX"
          v-mask="'+55 (##) #####-####'"
        )
        el-button.mt-20(@click="addPhone" type="primary") Adicionar telefone
        div(style="margin-top: 10px;")
          el-tag(
            v-for="(telefone, index) in informacoesContatos.telefones",
            :key="index",
            closable
            type="info"
            size="medium"
            style="margin: 5px"
            @close="removePhone(index)"
          ) {{ telefone }}
      el-col(:span="12")
        app-label(label="E-mail para contato", :required="true")
        el-input.full-width(
          v-model="tempEmail"
          type="email"
          placeholder="Digite o e-mail"
        )
        el-button.mt-20(@click="addEmail" type="primary") Adicionar e-mail
        div(style="margin-top: 10px;")
          el-tag(
            v-for="(email, index) in informacoesContatos.emails",
            :key="index",
            closable
            type="info"
            size="medium"
            style="margin: 5px"
            @close="removeEmail(index)"
          ) {{ email }}
</template>

<script>
import estadosBr from '@/constants/estados'
import AppLabel from '@/components/AppLabel'
import { mapActions } from 'vuex'

export default {
  components: {
    AppLabel
  },
  props: {
    contato: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      informacoesContatos: {
        ...this.contato,
        ...{
          emails: [],
          telefones: []
        }
      },
      estadosBr,
      municipios: [],
      tempTelefone: '',
      tempEmail: ''
    }
  },
  async mounted () {
    this.informacoesContatos.emails = this.contato.emails || []
    this.informacoesContatos.telefones = this.contato.telefones || []
    this.informacoesContatos.municipio = this.contato?.municipio?.id ? this.contato.municipio : { id: null }
    if (this.informacoesContatos.estado) {
      this.municipios = await this.getMunicipiosByUf(this.informacoesContatos.estado)
    }
  },
  methods: {
    ...mapActions({
      getMunicipiosByUf: 'municipios/findMunicipiosByUf'
    }),
    async changeEstado () {
      this.informacoesContatos.municipio = {id: null}
      this.municipios = await this.getMunicipiosByUf(this.informacoesContatos.estado)
    },
    addPhone () {
      if (this.tempTelefone) {
        this.informacoesContatos.telefones.push(this.tempTelefone)
        this.tempTelefone = ''
        this.$emit('update-telefones', this.informacoesContatos.telefones)
      } else {
        this.$message.error('Por favor, insira um telefone válido.')
      }
    },
    addEmail () {
      if (this.tempEmail) {
        this.informacoesContatos.emails.push(this.tempEmail)
        this.tempEmail = ''
        this.$emit('update-emails', this.informacoesContatos.emails)
      } else {
        this.$message.error('Por favor, insira um e-mail válido.')
      }
    },

    removePhone (index) {
      this.informacoesContatos.telefones.splice(index, 1)
      this.$emit('update-telefones', this.informacoesContatos.telefones)
    },
    removeEmail (index) {
      this.informacoesContatos.emails.splice(index, 1)
      this.$emit('update-emails', this.informacoesContatos.emails)
    }
  },
  watch: {
    informacoesContatos: {
      handler (newVal) {
        this.$emit('update:contato', newVal)
      },
      deep: true
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/styles/_variables.scss";

.mb-20 {
  margin-bottom: 20px;
}
.mt-20 {
  margin-top: 20px;
}
.containerContatos {
  min-height: 50vh;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/components/AppFormularioContatos.vue